<template>
<div class="container wrap ">
  <div v-for="(x, index) in data.sort((a, b) => (new Date(a.date).getTime() - new Date().getTime(a.date)))"
       class="animation-bottom container--unit col-12 col-xl-3 col-lg-4 col-md-6 col-sm-12"
       :style="{animationDelay: (index / 10) + 's'}"
       :key="index"
       @click="viewSpeakUp(x)">

    <div class="container--unit__box">
      <div class="container--unit__ball container" :style="{background: 'linear-gradient(-45deg,' + x.cor1 + ' 0% , ' + x.cor2 + ') 100% '}">
        <span class="span-unit">{{ x.book_name }}</span>
      </div>
      <h3>{{x.lesson_name}}</h3>
      <h5>Order: {{x.lesson_order}}</h5>
      <h6 class="speakup_status">{{formatDate(x.date)}}</h6>
      <h4 class="speakup_status">{{getStatus(x.status)}}</h4>
      <div class="container--unit__btn container align-items-center justify-content-center">
        <button type="button" class="btn btn-rounded color-white btn-sm gradient-start" name="button">VIEW</button>
      </div>
    </div>
  </div>
</div>

</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'list',
  props: {
    data: {
      type: Array
    }
  },
  methods: {
    async viewSpeakUp (speakup) {
      this.$router.push(`/speakup/${speakup.id}`)
    },
    getStatus (status) {
      switch (status) {
        case 'A':
          return 'Waiting'
        case 'I':
          return 'Initiated'
        case 'F':
          return 'Finished'
        default:
          return ''
      }
    },
    formatDate (date) {
      if (!date)
        return ''

      return new Date(date.split('.').shift()).toLocaleString()
    }
  }
}
</script>

<style lang="scss" scoped>
.starenable {
    filter: grayscale(0%)!important;
}
.presential {
    background: #00C6FF;
    background: -webkit-gradient(linear, right top, left top, from(#00C6FF), color-stop(73%, #035BCD), to(#0435BB));
    background: linear-gradient(-90deg, #00C6FF 0%, #035BCD 73%, #0435BB 100%);
}
.container--unit {
    padding: 7px 13px;
    box-sizing: border-box;
    margin-top: 25px;
    position: relative;
    .container--unit__box {
        background: #FFFFFF;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,0.08), 0 6px 7px 0 rgba(0,0,0,0.04);
        border-radius: 20px;
        box-sizing: border-box;
        border: 2px solid rgb(82, 82, 82);
        text-align: center;
        transition: 0.3s;
        display:flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        &:hover {
            transform: scale(1.06);
            background: #dfdfdf;
            box-shadow: 5px 5px 5px 1px rgba(0, 0, 0, 0.2);
        }
        .container--unit__title {
            font-size: 14px;
            text-align: center;
            color: #717171;
        }
        .container--unit__star {
            margin: 10px 0px;
            img {
                filter: grayscale(100%);
                margin-left: 5px;
            }
        }
        .container--unit__btn {
            margin: 20px 0px 10px 0px;
        }
        .container--unit__ball {
            width: 105px;
            height: 55px;
            margin-top: -20px;
            border-radius: 15px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
            text-align: center;
            // margin: 0 auto;
            // flex-direction: column;
            // position: relative;
            span {
                font-size: 15px;
                font-weight: 300
                // position: absolute;
                // top: 8px;
                // left: 0;
                // width: 100%;
                // text-align: center;
            }
            h3 {
                font-size: 40px;
                margin-left: 5px;
                font-weight: 400;
            }
        }
    }
    &__cover {
      cursor: not-allowed;
      position: absolute;
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 100%;
      height: calc(100% + 40px);
      bottom: 0;
      right: 0;
      flex-direction: column;
      background-color: rgba(#F3F3F3, 0.5);
      &:hover {
        svg {
          width: 85px;
          height: 85px;
          color:#c43232;
          background: rgba(#e84c4c, 0.5);
          padding: 5px;
          border-radius: 50px;
        }
      }
      svg {
        width: 80px;
        height: 80px;
        margin-top: 20px;
        color: #7f7f7f;
        transition: all .2s;
        background: rgba(#F3F3F3, 0.5);
        padding: 5px;
        border-radius: 50px;
      }
      p{
        background: #ffffffbf;
        padding: 6px 30px;
        border-radius: 30px;
        color: #e84c4c;
      }
    }
}

.disabled {
  &, & * {
    cursor: not-allowed;
  }
}

.speakup_status {
  margin: 5px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/speakup/list.vue